import React from 'react';
interface TrustLineProps {
  items: string[];
}
export function TrustLine({
  items
}: TrustLineProps) {
  return <p className="mt-2 text-center text-xs font-semibold uppercase tracking-wide text-muted sm:text-sm" data-id="element-192" data-mp="3oxdpw95eg11l">
      {items.map((item, i) => <React.Fragment key={item} data-id="element-193" data-mp="3kyxylt2ac6id" data-mpi={i}>
          {i > 0 && <span className="mx-1.5 text-steel" data-id="element-194" data-mp="3fyimf4tqp51z">|</span>}
          {item}
        </React.Fragment>)}
    </p>;
}